import { ReactNode } from 'react';

interface ContentContainerProps {
  children: ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | '8xl' | 'full';
}

const maxWidthClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
  '8xl': 'max-w-[1800px]',
  full: 'max-w-full',
};

export default function ContentContainer({ 
  children, 
  className = '', 
  maxWidth = '7xl' 
}: ContentContainerProps) {
  return (
    <div className={`w-full min-w-0 max-w-full overflow-x-hidden ${maxWidthClasses[maxWidth]} mx-auto py-8 px-4 box-border ${className}`}>
      {children}
    </div>
  );
}

